export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-slack-white-bg-shape@2x.997463fbed803fc08b9652fbfd602644.png";